import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Redirect, Link } from 'react-router-dom';
import Functions from '../../api/Functions';
import M from 'materialize-css';
import LinkCard from '../general/LinkCard';

function Migrations(props) {
  const [loading, setLoading] = useState(false);
  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const runFunction = (fbFunction) => {
    setLoading(true);
    fbFunction
      .then((response) => {
        console.log('Migration:', response);
        setLoading(false);
        M.toast({ html: 'Execution finished' });
      })
      .catch((e) => {
        console.log('Error in migration:', e.message);
        setLoading(false);
      });
  };

  const createdAtToAllProfiles = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>
                Add <b>createdAt</b> field to all profiles
              </p>
            </div>
            <div className="card-action">
              <Link to={window.location} onClick={() => runFunction(Functions.addCreationDateToAllProfiles())}>
                Update Profiles
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const assignContactListToAllProfiles = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>
                Upsert Contact List to All Profiles
              </p>
            </div>
            <div className="card-action">
              <Link to={window.location} onClick={() => runFunction(Functions.assignContactListToAllProfiles())}>
                Upsert Contacts
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const updateGenderField = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>
                Update Gender Field
              </p>
            </div>
            <div className="card-action">
              <Link to={window.location} onClick={() => runFunction(Functions.updateGenderField())}>
                Update Gender Field
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const updateLicenseTypeField = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>
                Update License Type
              </p>
            </div>
            <div className="card-action">
              <Link to={window.location} onClick={() => runFunction(Functions.updateLicenseTypeField())}>
                Update License Type Field
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const addFieldsToPyns = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>Add Fields to Pyns</p>
              <p>- createdAt</p>
              <p>- updatedAt</p>
              <p>- tlGeoFencesSet</p>
            </div>
            <div className="card-action">
              <Link to={window.location} onClick={() => runFunction(Functions.migrationPyns96())}>
                Add Fields
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const addFieldsToCompany = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>Add Fields to Company</p>
              <p>- createdAt</p>
              <p>- updatedAt</p>
              <p>- geoFenceColSetTL</p>
            </div>
            <div className="card-action">
              <Link to={window.location} onClick={() => runFunction(Functions.migrationCompanies96())}>
                Add Fields
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const addIdToUserContestCounters = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>Add id to User Contest Counters</p>
            </div>
            <div className="card-action">
              <Link to={window.location} onClick={() => runFunction(Functions.addIdToUserContestCounters())}>
                Add id
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const addNameToUserContestCounters = () => {
    return <LinkCard title="Add name to User Contests Counters" actionText="Add name" onClick={() => runFunction(Functions.addNameToUserContestCounters())} />
  }

  return (
    <div className="container">
      <div className="title-section">Run Migrations</div>
      {loading ? <h4>Processing...</h4> : <div />}
      <div className="row">
        {createdAtToAllProfiles()}
        {assignContactListToAllProfiles()}
        {updateGenderField()}
        {updateLicenseTypeField()}
        {addFieldsToPyns()}
        {addFieldsToCompany()}
        {addIdToUserContestCounters()}
        <LinkCard title={'Peace Hill Notification Migration'} link={'/migrations'} onClick={() => runFunction(Functions.peaceHillContestNotificationMigration())} />
        {addNameToUserContestCounters()}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    databases: state.firestore.ordered.databases,
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps))(Migrations);
